import * as React from 'react';
import { createStyles, Navbar, Badge } from '@mantine/core';
import routes from "../../routes";
import { Link, useLocation } from "react-router-dom";
import logo from '../../assets/images/logo.png';
import UserProfile from "../../components/user-profile";
import useStore from "../../store";

const useStyles = createStyles((theme, _params, getRef) => {
    const icon = getRef('icon');
    return {
        navbar: {
            background: theme.fn.gradient(),
            display: 'flex',
        },

        header: {
            paddingBottom: 7,
            marginBottom: theme.spacing.md * 1.5,
            borderBottom: `1px solid ${theme.fn.lighten(
                theme.fn.variant({ variant: 'filled', color: theme.primaryColor }).background!,
                0.1
            )}`,
            flex: '1 !important',
            overflow: 'auto'
        },

        groupHeader: {
            paddingTop: 7,
            borderBottom: `1px solid ${theme.fn.lighten(
                theme.fn.variant({ variant: 'filled', color: theme.primaryColor }).background!,
                0.1
            )}`,
            color: theme.white,
            fontSize: 18,
        },

        footer: {
            paddingTop: theme.spacing.md,
            marginTop: theme.spacing.md,
            borderTop: `1px solid ${theme.fn.lighten(
                theme.fn.variant({ variant: 'filled', color: theme.primaryColor }).background!,
                0.3
            )}`,
        },

        link: {
            ...theme.fn.focusStyles(),
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
            fontSize: theme.fontSizes.sm,
            color: theme.white,
            padding: `${theme.spacing.xs}px ${theme.spacing.sm}px`,
            borderRadius: theme.radius.sm,
            fontWeight: 500,

            '&:hover': {
                backgroundColor: theme.fn.lighten(
                    theme.fn.variant({ variant: 'filled', color: theme.primaryColor }).background!,
                    0.1
                ),
            },
        },

        linkIcon: {
            ref: icon,
            color: theme.white,
            opacity: 0.75,
            marginRight: theme.spacing.sm,
        },

        linkActive: {
            '&, &:hover': {
                backgroundColor: theme.fn.lighten(
                    theme.fn.variant({ variant: 'filled', color: theme.primaryColor }).background!,
                    0.15
                ),
                [`& .${icon}`]: {
                    opacity: 0.9,
                },
            },
        },
        logo: {
            '&:hover': {
                cursor: 'pointer'
            },
            textAlign: 'center',
            '> img': {
                width: 100,
            }
        },
        menuWrapper: {
            overflowY: 'auto'
        }
    };
});

function NavbarSimpleColored() {
    const location = useLocation();
    const { classes, cx } = useStyles();
    const stats = useStore(state => state.stats.songRequest);

    const currentRouteObject = React.useMemo(() => {
        return routes.find(route => route.path === location.pathname)
    }, [location.pathname]);

    const links = routes.filter(route => route.visible).map((route) => {
        if (route.isGroupHeader) {
            return (
                <div className={classes.groupHeader} key={route.key}>
                    {route.name}
                </div>
            )
        }
        const isActive = route.path === location.pathname || currentRouteObject?.menuKey === route.key;
        const RouteIcon = route.icon as React.ElementType || undefined;
        let badgeCount = 0;
        if (route.key === 'song-modify-request') {
            badgeCount = stats?.modify ?? 0;
        }
        if (route.key === 'song-file-request') {
            badgeCount = stats?.file ?? 0;
        }
        return (
            <Link
                key={route.key}
                className={
                    cx(
                        classes.link,
                        // classes.linkActive
                        { [classes.linkActive]: isActive }
                    )}
                to={route.path}
            >
                {
                    RouteIcon && (
                        <RouteIcon className={classes.linkIcon} stroke={1.5} />
                    )
                }
                <span>{route.name}</span>
                {
                    badgeCount > 0 && (
                        <Badge color="red" size="xs" variant="filled" ml='md'>{badgeCount}</Badge>
                    )
                }
            </Link>
        )
    });

    return (
        <Navbar width={{ sm: 300 }} p="md" className={classes.navbar}>
            <Navbar.Section className={classes.header}>
                <div className={classes.logo}>
                    <img
                        src={logo}
                        alt={'Duul Logo'}
                    />
                </div>
                <div className={classes.menuWrapper}>
                    {links}
                </div>
            </Navbar.Section>

            <Navbar.Section className={classes.footer}>
                <UserProfile/>
            </Navbar.Section>
        </Navbar>
    );
}

export default NavbarSimpleColored;